module.exports = __webpack_public_path__ + "img/kefu.d04e245c.png";